<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-con">
            <div class="modal-txt">
              <div class="txt-ttl">길찾기</div>
              <div class="txt-con">
                <pre>어떤 앱으로 안내할까요?</pre>
              </div>
            </div>
            <ul class="navi-select-list">
              <li>
                <button type="button" class="navi-select-btn" @click="selectTmap">
                  <img src="@/assets/static/images/ico-tmap-navi.svg" alt="" class="navi-opt-icon" />
                  <span>티맵</span>
                </button>
              </li>
              <li>
                <button type="button" class="navi-select-btn" @click="selectKakao">
                  <img src="@/assets/static/images/ico-kakaomap-navi.svg" alt="" class="navi-opt-icon" />
                  <span>{{ kakaoLabel }}</span>
                </button>
              </li>
            </ul>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn" @click="close">취소</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// 길찾기 앱 선택 모달. 호출부에서 onTmap / onKakao 콜백과 kakaoLabel(카카오맵 | 카카오내비)을 data로 넘긴다.
// 아이콘은 사용자 제공 공식 에셋만 사용(자작 금지): 티맵=ico-tmap-navi.svg, 카카오=ico-kakaomap-navi.svg.
const props = defineProps(['data']);
const { onTmap, onKakao } = props.data;
const kakaoLabel = props.data.kakaoLabel || '카카오맵';
const emits = defineEmits(['close']);

const close = () => {
  // 200ms = dim 페이드 아웃 대기(하우스 모달 패턴: alert.vue / CompanyModal.vue 동일).
  setTimeout(() => {
    emits('close');
  }, 200);
};

const selectTmap = () => {
  if (onTmap) onTmap();
  close();
};

const selectKakao = () => {
  if (onKakao) onKakao();
  close();
};
</script>

<style scoped>
.navi-select-list {
  margin-top: 16px;
}
.navi-select-list li {
  margin-bottom: 10px;
}
.navi-select-list li:last-child {
  margin-bottom: 0;
}
.navi-select-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #222;
  cursor: pointer;
}
.navi-opt-icon {
  width: 20px;
  height: 20px;
}
</style>
